<template>
  <div id="app">
    <header-component @updateParent="updateLang"></header-component>
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
    <footer-component :lang="lang"></footer-component>
  </div>
</template>

<script>
import AOS from "aos";
import HeaderComponent from "./components/shared/Header.vue";
import FooterComponent from "./components/shared/Footer.vue";

export default {
  name: "app",
  data() {
    return {
      lang: "it",
    };
  },
  head: {
    script: [
      {
        type: "text/javascript",
        src: "https://cs.iubenda.com/autoblocking/3568705.js",
      },
      { type: "text/javascript", src: "//cdn.iubenda.com/cs/gpp/stub.js" },
      {
        type: "text/javascript",
        src: "//cdn.iubenda.com/cs/iubenda_cs.js",
        async: true,
      },
    ],
  },
  components: {
    HeaderComponent,
    FooterComponent,
  },
  methods: {
    updateLang(lang) {
      this.lang = lang;
    },
  },
  beforeCreate() {
    _iub.csConfiguration.lang = this.$i18n.locale;
  },
  mounted() {
    AOS.init({
      startEvent: "DOMContentLoaded",
      once: true,
      offset: 50,
    });

    console.log('mounted')
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  list-style: none;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
a,
a:visited,
a:active,
a:hover {
  color: inherit;
  text-decoration: none;
}
html,
body {
  position: relative;
  scroll-behavior: smooth;
}
body {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-style: normal;
  overscroll-behavior: none;
  transition: opacity 0.8s;
  color: #33586e;
  &.lock {
    height: 100%;
    overflow: hidden;
  }
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  color: #33586e;
}
b {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
}
.light {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-style: normal;
}
input:focus,
select {
  outline: none;
}
img {
  filter: blur(0);
  opacity: 1;
  transition: filter 0.25s ease-out, opacity 0.1s ease-out;
  &.blur {
    opacity: 0;
    filter: blur(20px);
  }
}
html,
html:not(.no-js) {
  [data-aos="fade-skew"] {
    transform: translate3d(0, 100px, 0) rotateZ(5deg);

    &.aos-animate {
      opacity: 1;
      transform: translate3d(0, 0, 0) skewX(0) rotateZ(0);
    }
  }
}
a.quote-link {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// App.vue?26328d59